export const partners = {
    pacifico: "Pacífico",
    callcenter: "Callcenter",
    bcp: "BCP",
    bcppyme: "BCPPyme",
};
